// extracted by mini-css-extract-plugin
module.exports = {"pt-promotion-table":"pt-promotion-table-1f91caf4c8e795a484dcc362a9311767"};